// Общие помощники canvas-экспорта картинок ФНФ Лиги (таблица группы, результаты игры).
// Паттерн ручного рендера — как в src/views/players/exportRatingImage.js (html2canvas в проекте нет).

export const COLORS = {
  background: '#161d31',
  cardTop: '#7367f0',
  headerText: '#ffffff',
  rowEven: '#283046',
  rowOdd: '#212a3e',
  rowHighlight: '#3d3670', // подсветка призовых строк (тёмный фиолетовый в тон шапке)
  text: '#d0d2d6',
  accent: '#ffd166',
  muted: '#8a99b5',
}

// Шрифт — 'Montserrat', как реально загружен в проекте (public/index.html,
// $font-family-sans-serif в _variables.scss). exportRatingImage.js использует
// 'Inter', но этот шрифт нигде в приложении не подключён — там это фоллбек
// на system-ui без реальной загрузки. Берём фактически доступный шрифт,
// чтобы document.fonts.ready его дождался.
export const FONT_FAMILY = '"Montserrat", sans-serif'

export async function ensureFontsReady() {
  if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
    try {
      await document.fonts.ready
    } catch (_) {
      // если по какой-то причине шрифты не готовы — продолжаем с системным фоллбеком
    }
  }
}

export function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) reject(new Error('canvas.toBlob returned null'))
      else resolve(blob)
    }, 'image/png')
  })
}

export function triggerDownload(blob, name) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

// перенесено из exportRatingImage.js: обрезка текста по ctx.measureText с многоточием
export function ellipsize(ctx, text, maxWidth) {
  if (maxWidth <= 0) return ''
  if (ctx.measureText(text).width <= maxWidth) return text
  const ellipsis = '…'
  let lo = 0
  let hi = text.length
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2)
    const candidate = text.slice(0, mid) + ellipsis
    if (ctx.measureText(candidate).width <= maxWidth) lo = mid
    else hi = mid - 1
  }
  return text.slice(0, lo) + ellipsis
}
